<template>
  <van-row gutter="20">
    <van-col :span='titleSpan' class='col-title'>
      {{ title }}
    </van-col>
    <van-col :span='24 - titleSpan'>
      <van-field v-model="val" :placeholder='placeholder'/>
    </van-col>
  </van-row>
</template>

<script>
export default {
  data() {
    return {
      val: this.initVal
    }
  },
  props: {
    title: {
      type: String,
      default: null
    },
    titleSpan: {
      type: Number,
      default: 6
    },
    initVal: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: '请填写'
    }
  },
  watch: {
    val(val) {
      this.$emit('change', val);
    }
  }
}
</script>

<style scoped>
.col-title {
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/components/base/BaseField.vue